import { db } from "~/db/db";

export const getOrganizedDates = ({data = []}) => {
    let dates = {};

    data.forEach((el) => {
        const key = el.createdAt.split("T")[0];
        if(!dates[key]){
          dates[key] = [];
        }

        dates[key].push(el);
    })

    let tempDates = Object.keys(dates).sort((a,b) => {
        const dateA = new Date(a);
        const dateB = new Date(b);

        return dateA - dateB;
    })

    return {
        lastDate: tempDates.length > 0 ? tempDates[tempDates.length - 1] : null,
        dates
    }
}

export const getBiggerDate = ({data = [], field_name = 'createdAt'}) => {
    let biggerCreatedDate = null;
    data.forEach(e => {
        const date = new Date(e[field_name]);
        if(!biggerCreatedDate || date > biggerCreatedDate){
            biggerCreatedDate = date;
        }
    })

    return biggerCreatedDate;
}

export const getBiggerDateArray = ({data = []}) => {
    const bigger = data.toSorted((a,b) => {
    if(a && b){
      const dateA = new Date(a);
      const dateB = new Date(b);

      return dateA - dateB;
    }else{
      return null;
    }
  })

  return {
    lastDate: bigger.length > 0 ? bigger[bigger.length - 1] : null
  }
}

export const getOrderedDatesArray = ({data = []}) => {
  return data.sort((a,b) => {
    if(a && b){
      const dateA = new Date(a);
      const dateB = new Date(b);

      return dateA - dateB;
    }else{
      return null;
    }
  })
}

export const getColumnIntoKey = ({data = [], key = "id", prefix = "id" }) => {
  return data.reduce((acc, cur) => {
    acc[`${prefix}${cur[key]}`] = cur;
    return acc;
  }, {});
}

export const toFixCache = async ({data = [], clienteId}) => {
  if(data?.length == 0){
    const temp = [];
    await db.mapaDaMina.where('clienteId').equals(clienteId).and(c => typeof c.id != 'string').each((c) => temp.push(c));

    if(temp?.length > 0){
      await db.mapaDaMina.where('clienteId').equals(clienteId).and(c => typeof c.id != 'string').delete();
    }

    return;
  }

  let toRemove = [];
  let toAdd = [];

  const indexDbItens = [];
  await db.mapaDaMina.where('clienteId').equals(clienteId).and(c => typeof c.id != 'string').each((c) => indexDbItens.push(c));
  let indexDbIds = getColumnIntoKey({data: indexDbItens, prefix: "id-"});
  const dbIds = getColumnIntoKey({data: data, prefix: "id-"});

  const historyIds =  [];
  await db.mapaDaMinaNaoIds.where('clienteId').equals(clienteId).each((c) => historyIds.push(c));

  //CHECA SE UM ID EXISTE NA BASE DE DADOS E NÃO EXISTE NO INDEXDB, E O ADICIONA
  for(const [key, value] of Object.entries(dbIds)){
    if(!indexDbIds[key]) toAdd.push(value);
  }

  const objHistoryIds = getColumnIntoKey({data: historyIds, prefix: "id-"});

  //CHECA SE UM ID ESTÁ INATIVO NA BASE DE DADOS, E O REMOVE DO INDEX
  for(const [key, value] of Object.entries(objHistoryIds)){
    if(indexDbIds[key]) toRemove.push(value.id);
  }

  if(toRemove?.length > 0){
    await db.mapaDaMina.where('clienteId').equals(clienteId).and(c => toRemove.includes(c.id)).delete();
  }

  if(toAdd?.length > 0){
    await db.mapaDaMina.bulkAdd(toAdd);
  }
}